import { Component, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { ServersideAlertService } from 'src/app/core/services/onboarding/serverside-alert.service';

@Component({
  selector: 'app-serverside-alert',
  templateUrl: './serverside-alert.component.html',
  styleUrls: ['./serverside-alert.component.scss'],
})
export class ServersideAlertComponent implements OnDestroy {
  style: 'success' | 'warn' | 'error' = 'success';
  messages: string[] = [];
  alertReported = false;
  color = '';
  backgroundColor = '';
  private subscriptions = new Subscription();

  constructor(private ssas: ServersideAlertService) {
    this.subscriptions.add(
      this.ssas.alertStyle$.subscribe((style) => {
        this.style = style;
      })
    );
    this.subscriptions.add(
      this.ssas.alertMessages$.subscribe((messages) => {
        this.messages = messages;
      })
    );
    this.subscriptions.add(
      this.ssas.alertReported$.subscribe((reported) => {
        this.alertReported = reported;
      })
    );
    this.subscriptions.add(
      this.ssas.color$.subscribe((color) => {
        this.color = color;
      })
    );
    this.subscriptions.add(
      this.ssas.backgroundColor$.subscribe((backgroundColor) => {
        this.backgroundColor = backgroundColor;
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
